import { computed } from "vue";
import { useRoute } from "vue-router";
import { useCursoStore } from "@/store/cursoStore";
import { useUserStore } from "@/store/userStore";
import { resolveAppSection, } from "@/navigation/appSections";
import { routeHidesBottomNav, shouldShowBottomNavigation, } from "@/navigation/bottomNavVisibility";
import { authService } from "@/services/authService";
import { isAcademicStaffCourse } from "@/utils/funcionarios";
import { isAlumnosCourse } from "@/utils/parseCourseCode";
export const useBottomNavShell = () => {
    const route = useRoute();
    const cursoStore = useCursoStore();
    const userStore = useUserStore();
    const activeCurso = computed(() => {
        const fromStore = cursoStore.selectedCursoData;
        if (fromStore)
            return fromStore;
        return cursoStore.getCursoData() ?? null;
    });
    const isAuthenticated = computed(() => {
        void route.fullPath;
        const email = String(userStore.email ||
            localStorage.getItem("userEmail") ||
            localStorage.getItem("email") ||
            "").trim();
        return Boolean(email) && authService.isAuthenticated();
    });
    const isBottomNavActive = computed(() => shouldShowBottomNavigation(route, activeCurso.value, userStore.email, isAuthenticated.value));
    const activeSection = computed(() => {
        if (!isBottomNavActive.value)
            return null;
        if (routeHidesBottomNav(route))
            return null;
        const section = resolveAppSection(route);
        const name = typeof route.name === "string" ? route.name : "";
        const academicHome = isAlumnosCourse(activeCurso.value) ||
            isAcademicStaffCourse(activeCurso.value);
        if (academicHome && name.startsWith("asignaciones-")) {
            return "treasury";
        }
        return section;
    });
    const showBottomNav = computed(() => isBottomNavActive.value);
    return {
        activeCurso,
        isBottomNavActive,
        activeSection,
        showBottomNav,
    };
};
